import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19cf15ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "menu-wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "icon sideBarIcon",
  "aria-hidden": "true"
}
const _hoisted_3 = ["xlink:href"]
const _hoisted_4 = {
  key: 1,
  class: "icon sideBarIcon",
  "aria-hidden": "true"
}
const _hoisted_5 = ["xlink:href"]
const _hoisted_6 = { style: {"margin-left":"10px"} }
const _hoisted_7 = ["id"]
const _hoisted_8 = {
  key: 0,
  class: "icon sideBarIcon",
  "aria-hidden": "true"
}
const _hoisted_9 = ["xlink:href"]
const _hoisted_10 = {
  key: 1,
  class: "icon sideBarIcon",
  "aria-hidden": "true"
}
const _hoisted_11 = ["xlink:href"]
const _hoisted_12 = { style: {"margin-left":"10px"} }

import {transformI18n} from '@/langs/i18n';

import {useRoute} from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarItem',
  props: {
  item: {
    type: Object,
    required: true,
  },
  isNest: {
    type: Boolean,
    default: false,
  },
  basePath: {
    type: String,
    default: '',
  },
},
  setup(__props) {



const hasOneShowingChild = (children = []) => children.length === 0;

const isSelectItem = (item) => {
  if (!item) {
    return false;
  }
  const route = useRoute();
  const routPath = route.path;
  if (routPath === item.path) {
    return true;
  }
  const basePath = route?.meta?.basePath;
  if (basePath) {
    return basePath.includes(item.path);
  }
  if (item.children) {
    const {children} = item;
    let isChildSelected = false;
    for (const row of children) {
      if (routPath === row.path) {
        isChildSelected = true;
        break;
      }
    }
    return isChildSelected;
  }
  return false;
};

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_sidebar_item = _resolveComponent("sidebar-item", true)!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!

  return (!__props.item.hidden)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (hasOneShowingChild(__props.item.children))
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 0,
              class: _normalizeClass(["item", {'submenu-title-noDropdown':!__props.isNest, 'is-active': isSelectItem(__props.item)}]),
              id: __props.item.id,
              index: __props.item.path
            }, {
              default: _withCtx(() => [
                (__props.item.icon && isSelectItem(__props.item))
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [
                      _createElementVNode("use", {
                        "xlink:href": `#${__props.item.activeIcon}`
                      }, null, 8, _hoisted_3)
                    ]))
                  : (__props.item.icon)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [
                        _createElementVNode("use", {
                          "xlink:href": `#${__props.item.icon}`
                        }, null, 8, _hoisted_5)
                      ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(transformI18n)(__props.item.navItem)), 1)
              ]),
              _: 1
            }, 8, ["id", "index", "class"]))
          : (_openBlock(), _createBlock(_component_el_sub_menu, {
              key: 1,
              ref: "subMenu",
              index: __props.item.path
            }, {
              title: _withCtx(() => [
                _createElementVNode("div", {
                  class: "item",
                  id: __props.item.id,
                  style: {"margin-left":"20px"}
                }, [
                  (isSelectItem(__props.item))
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_8, [
                        _createElementVNode("use", {
                          "xlink:href": `#${__props.item.activeIcon}`
                        }, null, 8, _hoisted_9)
                      ]))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_10, [
                        _createElementVNode("use", {
                          "xlink:href": `#${__props.item.icon}`
                        }, null, 8, _hoisted_11)
                      ])),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(transformI18n)(__props.item.navItem)), 1)
                ], 8, _hoisted_7)
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.children, (child) => {
                  return (_openBlock(), _createBlock(_component_sidebar_item, {
                    "is-nest": true,
                    item: child,
                    key: child.path,
                    "base-path": child.path,
                    class: "nest-menu"
                  }, null, 8, ["item", "base-path"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["index"]))
      ]))
    : _createCommentVNode("", true)
}
}

})